// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    /**
     * Checks if an element is visible within the viewport.
     * @param {HTMLElement} element - The element to check visibility for.
     * @param {boolean} partial - Whether partial visibility counts as visible.
     * @returns {boolean} - True if the element is visible, false otherwise.
     */
    function isElementVisible(element, partial) {
        // Get the current scroll position
        const viewTop = window.pageYOffset || document.documentElement.scrollTop;
        const viewBottom = viewTop + window.innerHeight;
    
        // Get the bounding rectangle of the element
        const rect = element.getBoundingClientRect();
        const elemTop = rect.top + viewTop; // Element's top position relative to the document
        const elemBottom = elemTop + rect.height; // Element's bottom position relative to the document
    
        // Determine the positions to compare based on partial visibility
        const compareTop = partial ? elemBottom : elemTop;
        const compareBottom = partial ? elemTop : elemBottom;
    
        // Return true if the element is within the viewport, false otherwise
        return compareBottom <= viewBottom && compareTop >= viewTop;
    }
    

    /**
     * Handles the animation of elements when they come into view.
     */
    function animateOnScroll() {
        // Select all elements that should animate when in view
        const animatedElements = document.querySelectorAll('.animate-in');

        /**
         * Updates the visibility class of an element based on its visibility.
         * @param {HTMLElement} el - The element to update.
         */
        function updateVisibility(el) {
            // Add 'already-visible' class if the element is visible and doesn't already have it
            if (isElementVisible(el, true) && !el.classList.contains('already-visible')) {
                el.classList.add('already-visible');
            }
            // Remove 'already-visible' class if the element is not visible but has it
            else if (!isElementVisible(el, true) && el.classList.contains('already-visible')) {
                console.log(el)
                el.classList.remove('already-visible');
            }
        }

        /**
         * Handles the scroll event to animate elements as they come into view.
         */
        function handleScroll() {
            // Iterate over each animated element
            animatedElements.forEach((el) => {
                // Add 'is-animated' class if the element is visible and doesn't already have it
                if (isElementVisible(el, true) && !el.classList.contains('is-animated')) {
                    el.classList.add('is-animated');
                }
            });
        }

        // Initial check to update visibility classes for elements already in view
        animatedElements.forEach(updateVisibility);

        // Add scroll event listener to handle animations on scroll
        window.addEventListener('scroll', handleScroll, { capture: true, passive: true });
    }

    // Initialize the scroll animation handling
    animateOnScroll();
});
